<template>
  <div>
    <v-app-bar class="main-header-mobile" app>
      <div class="py-2 d-flex align-end">
        <router-link class="d-flex" to="/">
          <img :src="logo" class="logo" />
        </router-link>
      </div>
      <v-spacer />

      <v-menu
        left
        :close-on-content-click="false"
        min-width="calc(100% - 24px)"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon>fas fa-search</v-icon>
          </v-btn>
        </template>

        <Search small />
      </v-menu>

      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <div class="px-8 py-6 d-flex flex-column">
        <router-link to="/" class="d-flex">
          <img :src="logo" class="logo" />
        </router-link>
      </div>
      <v-divider></v-divider>
      <v-list-item-group v-model="current">
        <v-list>
          <v-list-item v-for="(route, i) in menu" :key="i" :to="route.to" link>
            <v-list-item-content>
              <v-list-item-title class="text-body-2 font-weight-bold">
                {{ route.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-group>
      <v-divider></v-divider>
      <v-list-item-group>
        <v-list>
          <v-list-item
            v-for="(route, i) in categories"
            :key="i"
            :to="route.to"
            link
          >
            <v-list-item-content>
              <v-list-item-title class="text-body-2">
                {{ route.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-group>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "@/components/utils";
import Search from "@/components/widgets/Search.vue";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
    whatsappLink() {
      return getWhatsappLinkFromPhone(
        this.$rest("informations").item.whatsapp || ""
      );
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  components: {
    Search,
  },
};
</script>

<style>
.main-header-mobile {
  z-index: 999 !important;
}
.main-header-mobile .logo {
  height: 42px;
}

.v-navigation-drawer__content .logo {
  width: 100%;
}
.v-navigation-drawer {
  z-index: 9999 !important;
}
</style>
